import { Injectable, NgZone } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { grpc } from '@improbable-eng/grpc-web';

import {
  PageRequest,
  PageResponse,
} from '../gateway/page_pb';

import {
  PageService as __PageService,
} from '../gateway/page_pb_service';

/**
  Useful for TOS and privacy policy.
  */
@Injectable({providedIn: 'root'})
export class PageService {

  constructor(private _ngZone: NgZone) {
  }

  readPage(request: PageRequest): Promise<PageResponse>;
  readPage(request: PageRequest, metadata: grpc.Metadata): Promise<PageResponse>;
  readPage(request: PageRequest, callback: (err: any|null, response: PageResponse, metadata: grpc.Metadata) => void): void;
  readPage(request: PageRequest, metadata: grpc.Metadata, callback: (err: any|null, response: PageResponse, metadata: grpc.Metadata) => void): void;

  readPage(request: PageRequest, arg1?: grpc.Metadata|((err: any|null, response: PageResponse, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: PageResponse, metadata: grpc.Metadata) => void): Promise<PageResponse>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<PageResponse>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__PageService.readPage, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

}

